import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
} from "../services/types/ComponentTypes";

export const screen_169_users_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Users",
        style: {},
        fabAction: {
            type: "add",
            screenId: "42",
            action: "modulev1/users_add",
        },
        childComponents: [
            {
                componentType: ComponentType.SUMMARY_LIST,
                Name: "user_summary",
                BindValue: "grid_emp",
                titleValue: "Users",
                SummeryActions: [
                    {
                        Action: {
                            Action: "Navigate",
                            Navigate: "modulev1/users_add/<id>",
                        },
                        ActionType: "Edit",
                        ScreenId: "42",
                    },
                    {
                        Action: {
                            Action: "Delete",
                            Module: "user_summary",
                        },
                        ActionType: "Delete",
                        ScreenId: "42",
                    },
                ],
                Form: {
                    Name: "user_summary",
                    TableName: "users",
                    DisplayName: "Users",
                    Query: "SELECT u.id, u.username, u.mobile_no AS mobile, u.role_id AS group_id, ug.group_name AS role, COALESCE(uc.username, NULLIF(TRIM(u.created_by::text), '')) AS created_by, u.created_at::date AS created_at FROM users u LEFT JOIN users uc ON uc.id::text = TRIM(u.created_by::text) LEFT JOIN user_group ug ON ug.id::text = TRIM(u.role_id::text) AND COALESCE(ug.soft_delete, 0) = 0 WHERE u.soft_delete = 0 AND COALESCE(NULLIF(TRIM(u.branch_id::text), ''), NULLIF(TRIM(u.transaction_branch_id::text), '')) = '<branch_id>' ORDER BY u.created_at DESC",
                    Fields: [
                        {
                            IncludeLabel: true,
                            Label: "id",
                            BindValue: "id",
                            Json_Attribute: "id",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: false,
                            IsPrimary: true,
                        },
                        {
                            IncludeLabel: true,
                            Label: "User name",
                            BindValue: "name",
                            Json_Attribute: "username",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                            IsPrimary: false,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Mobile",
                            BindValue: "txt_mobile",
                            Json_Attribute: "mobile",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                            IsPrimary: false,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Role",
                            BindValue: "txt_role",
                            Json_Attribute: "role",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                            IsPrimary: false,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Created by",
                            BindValue: "txt_created_by",
                            Json_Attribute: "created_by",
                            componentType: ComponentType.TEXT_FIELD,
                            showInSummary: true,
                        },
                        {
                            IncludeLabel: true,
                            Label: "Created at",
                            BindValue: "txt_created_at",
                            Json_Attribute: "created_at",
                            componentType: ComponentType.DATE_FIELD,
                            showInSummary: true,
                        },
                    ],
                },
            },
        ],
    },
];